import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DomainService } from '@shared/services';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@shared/services/language.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-language-change',
  templateUrl: './language-change.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LanguageChangeComponent implements OnInit, OnDestroy {
  languages: any = {
    en: 'EN',
    ja: 'JA',
    pt: 'PT',
    tr: 'TR',
    no: 'NO',
    pl: 'PL',
    es: 'ES',
    hu: 'HU',
  };

  language = '';
  domain: any = null;
  private languageSubscription: Subscription;

  constructor(
    public translate: TranslateService,
    public domainService: DomainService,
    private languageService: LanguageService,
  ) {
    this.domain = this.domainService.get;
  }

  ngOnInit() {
    this.domain = this.domainService.get;

    this.languageSubscription = this.languageService
      .getCurrentLanguage()
      .subscribe((currentLang: string) => {
        this.language = currentLang;
      });

    // Filter languages for speedy.io domain
    if (this.domain.domain === 'speedy.io') {
      for (const lang in this.languages) {
        if (lang !== 'en' && lang !== 'pt') {
          delete this.languages[lang];
        }
      }
    }

    this.translate.addLangs(Object.keys(this.languages));
  }

  langChange(lang: string) {
    this.languageService.language = lang;
  }

  ngOnDestroy() {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }
}
